export default "__VITE_ASSET__DzCez1Au__"